import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog from '@/components/Dialog.vue';
import PreviewImg from '@/components/PreviewImg.vue';
let CostomerManage = class CostomerManage extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.archiveStepper = 1;
        this.searchForm = {
            keyword: '',
            archiveCategory: '',
            sortBy: '',
            sortType: '',
        };
        this.orderTableOption = {
            loading: false,
            headers: [
                {
                    text: '医院',
                    align: 'left',
                    sortable: false,
                    value: 'hospitalId',
                    width: '150',
                },
                {
                    text: '档案类别',
                    align: 'center',
                    sortable: false,
                    value: 'archiveCategory',
                    width: '80',
                },
                {
                    text: '科室',
                    align: 'center',
                    sortable: false,
                    value: 'dept',
                    width: '150',
                },
                {
                    text: '主要负责人',
                    align: 'center',
                    sortable: false,
                    value: 'primaryPerson',
                    width: '80',
                },
                {
                    text: '负责人联系方式',
                    align: 'center',
                    sortable: false,
                    value: 'primaryPersonContact',
                    width: '150',
                },
                {
                    text: '骨干人员',
                    align: 'center',
                    sortable: false,
                    value: 'corePerson',
                    width: '80',
                },
                {
                    text: '骨干人员联系方式',
                    align: 'center',
                    sortable: false,
                    value: 'corePersonContact',
                    width: '120',
                },
                {
                    text: '科室总人数',
                    align: 'center',
                    sortable: false,
                    value: 'deptPersonCount',
                    width: '150',
                },
                {
                    text: '操作',
                    align: 'left',
                    sortable: false,
                    value: 'action',
                    width: '180',
                },
            ],
            desserts: [],
            pagination: {
                pageCount: 1,
                pageNow: 1,
                pageArr: [5, 10, 20, 50, '所有'],
                everyPageCount: 10,
                sumDetail: 0,
            },
        };
        this.dialogOrder = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.dialogDetailPivas = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            archiveData: {},
        };
        this.dialogDetailEndoscope = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            archiveData: {},
        };
        this.importDialog = {
            visible: false,
            loading: false,
            importing: false,
            searchKeyword: '',
            data: [],
            selected: [],
            headers: [],
            searchTimer: null,
        };
        this.detailTable = {
            data: {},
            headersPivas: [
                {
                    text: '药师人数',
                    value: 'pharmacistCount',
                },
                {
                    text: '护士人数',
                    value: 'nurseCount',
                },
                {
                    text: '其他人员',
                    value: 'otherPersonCount',
                },
                {
                    text: '日配药总量',
                    value: 'dayDispenseTotal',
                },
                {
                    text: '配药方式',
                    value: 'dispenseMode',
                },
                {
                    text: '操作',
                    value: 'tableAction',
                },
            ],
            headersEndoscope: [
                {
                    size: 2,
                    text: '洗消人数',
                    value: 'washPersonCount',
                },
                {
                    text: '洗消人数是否流动',
                    value: 'washPersonIsFlow',
                },
                {
                    size: 1,
                    text: '检查时间',
                    value: 'checkTime',
                },
                {
                    text: '接诊量/天',
                    value: 'dayPatientVisits',
                },
                {
                    size: 2,
                    text: '检查房间数',
                    value: 'checkRoomNum',
                },
                {
                    size: 2,
                    text: '检查床位数',
                    value: 'checkBedNum',
                },
                {
                    text: '操作',
                    value: 'tableAction',
                },
            ],
        };
        this.listHospital = []; // 医院信息
        this.operDateArray = ['deliveryDate', 'docDate', 'rdpConfirmDate', 'pdConfirmDate', 'salesAuditDate', 'gmApprovalDate'];
    }
    get dynamicHeight() {
        return `${window.innerHeight - 120}px`;
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.docDates.length > 0) {
            str = this.searchForm.docDates.join(' ~ ');
        }
        return str;
    }
    get deliveryDateRangeText() {
        let str = '';
        if (this.searchForm.deliveryDates.length > 0) {
            str = this.searchForm.deliveryDates.join(' ~ ');
        }
        return str;
    }
    // 医院列表
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios.get('/api/hospital', { params: { simple: true } }).then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    async getDataList() {
        const that = this;
        that.orderTableOption.loading = true;
        try {
            const res = await that.axios.get('/api/hospital/archive/info', {
                params: {
                    withProducts: true,
                    page: that.orderTableOption.pagination.pageNow,
                    limit: typeof that.orderTableOption.pagination.everyPageCount === 'number'
                        ? that.orderTableOption.pagination.everyPageCount
                        : that.orderTableOption.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    hospitalId: that.searchForm.hospitalId,
                    archiveCategory: !/全部|所有/.test(that.searchForm.archiveCategory) ? that.searchForm.archiveCategory : '',
                    sortBy: that.searchForm.sortBy,
                    sortType: that.searchForm.sortType,
                },
            });
            that.orderTableOption.desserts = (res.data.result || []).map((v) => {
                if (!v.endoscopeInfoList && !v.pivasList && !v.endoscopeInfoList.length && !v.pivasList.length)
                    return { ...v, endoscopeInfoList: [{}], pivasList: [{}] };
                return v;
            }) || [];
            that.orderTableOption.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.orderTableOption.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.orderTableOption.pagination.everyPageCount) || 1;
            that.orderTableOption.pagination.pageCount = pageCount;
            if (that.orderTableOption.pagination.pageNow > pageCount) {
                that.orderTableOption.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.orderTableOption.loading = false;
        }
    }
    async showDetialFormClick(operType, row, node) {
        if (row.archiveCategory === '内镜') {
            this.dialogDetailEndoscope.operType = operType;
            this.dialogDetailEndoscope.formData = Object.assign({}, node || {});
            if (operType === 'add') {
                this.dialogDetailEndoscope.title = '新增内镜信息';
            }
            else if (operType === 'edit') {
                this.dialogDetailEndoscope.title = '修改内镜信息';
            }
            else if (operType === 'detail') {
                this.dialogDetailEndoscope.title = '详细内镜信息';
            }
            else {
                this.dialogDetailEndoscope.title = '删除内镜信息';
            }
            this.dialogDetailEndoscope.archiveData = row;
            this.dialogDetailEndoscope.visible = true;
        }
        else {
            this.dialogDetailPivas.operType = operType;
            this.dialogDetailPivas.formData = Object.assign({}, node || {});
            if (operType === 'add') {
                this.dialogDetailPivas.title = '新增静配信息';
            }
            else if (operType === 'edit') {
                this.dialogDetailPivas.title = '修改静配信息';
            }
            else if (operType === 'detail') {
                this.dialogDetailPivas.title = '详细静配信息';
            }
            else {
                this.dialogDetailPivas.title = '删除静配信息';
            }
            this.dialogDetailPivas.archiveData = row;
            this.dialogDetailPivas.visible = true;
        }
    }
    /**
     * 显示订单表单
     */
    async showOrderFormClick(operType, row) {
        this.archiveStepper = 1;
        // 添加
        async function addFunc() {
            that.dialogOrder.title = '新增客户信息';
        }
        // 修改
        async function editFunc() {
            that.dialogOrder.title = '修改客户信息';
        }
        // 删除
        async function deleteFunc() {
            that.dialogOrder.title = '删除客户信息';
        }
        async function detail() {
            await editFunc();
            that.dialogOrder.title = '查看客户详情';
        }
        const that = this;
        that.dialogOrder.operType = operType;
        that.dialogOrder.formData = Object.assign({}, row || { endoscopeInfoList: [{}], pivasList: [{}] });
        that.dialogOrder.products = []; // 清空产品信息
        if (operType === 'add') {
            await addFunc();
        }
        else if (operType === 'edit') {
            await editFunc();
        }
        else if (operType === 'detail') {
            await detail();
        }
        else {
            await deleteFunc();
        }
        that.dialogOrder.visible = true;
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category == 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
        row.inboundType = '生产'; // 入库类型
    }
    addArrayData(data, prop, content) {
        if (!data[prop] || !data[prop].length) {
            this.$set(data, prop, [content]);
        }
        else {
            data[prop].push(content);
        }
    }
    deleteArrayData(data, prop, index) {
        // Check if index is valid
        if (index < 0 || index >= data[prop].length) {
            console.error('Index out of bounds');
            return;
        }
        // Ensure the item at the index has the property we're looking for
        if (data[prop] && data[prop][index]) {
            data[prop].splice(index, 1);
        }
        else {
            console.error('Item does not match the criteria');
        }
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return that.dialogOrder.operType === 'begin' || that.dialogOrder.operType === 'detail' || that.dialogOrder.operType === 'end';
    }
    async savePivasForm() {
        const that = this;
        const form = {
            ...that.dialogDetailPivas.formData,
            archiveId: this.dialogDetailPivas.archiveData.id,
        };
        let month = '';
        let url = '/api/hospital/archive/pivas';
        let msg = '';
        // 添加
        if (that.dialogDetailPivas.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogDetailPivas.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogDetailPivas.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        that.dialogDetailPivas.loading = true;
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
        that.dialogDetailPivas.loading = false;
        // 提示成功刷新页面
        that.dialogDetailPivas.visible = false;
    }
    async updateImage(data, prop, file) {
        // 新建一个formData对象
        const formData = new FormData();
        formData.append('file', file);
        const that = this;
        const res = await that.axios.post('/api/upload/files', formData);
        if (data[prop] && data[prop].length) {
            data[prop].push(res.data.result.url);
        }
        else {
            data[prop] = [res.data.result.url];
        }
    }
    async saveEndoscopeForm() {
        const that = this;
        const form = {
            ...that.dialogDetailEndoscope.formData,
            archiveId: this.dialogDetailEndoscope.archiveData.id,
        };
        let month = '';
        let url = '/api/hospital/archive/endoscope/info';
        let msg = '';
        // 添加
        if (that.dialogDetailEndoscope.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogDetailEndoscope.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogDetailEndoscope.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        that.dialogDetailEndoscope.loading = true;
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
        that.dialogDetailEndoscope.loading = false;
        // 提示成功刷新页面
        that.dialogDetailEndoscope.visible = false;
    }
    removeChips(data, prop, index) {
        data[prop].splice(index, 1);
    }
    /**
     * 保存订单表单
     */
    async saveOrderForm() {
        const that = this;
        const form = {
            ...that.dialogOrder.formData,
            products: that.dialogOrder.products || [],
        };
        // 格式化时间字段：将datetime-local格式转换为yyyy-MM-dd hh:mm:ss
        if (form.ptDispenseTime) {
            form.ptDispenseTime = form.ptDispenseTime.replace('T', ' ') + ':00';
        }
        if (form.hlyDispenseTime) {
            form.hlyDispenseTime = form.hlyDispenseTime.replace('T', ' ') + ':00';
        }
        let month = '';
        let url = '/api/hospital/archive/info';
        let msg = '';
        // 添加
        if (that.dialogOrder.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogOrder.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogOrder.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
    }
    /**
     * 发送客户信息
     */
    async sendOrderSalesResponse(op) {
        const that = this;
        await that.axios[op.month](op.url, op.form)
            .then((res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            that.snackbar.success(`${op.msg}创建信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${op.msg}信息错误${resMeg}`);
            console.log(`${op.msg}信息错误`, e);
        });
    }
    /**
     * 跳转参数处理
     */
    async skipParams() {
        const that = this;
        const params = this.$route.params || {};
        // 存在订单状态，那么就只需处理查询
        if (params.orderStatus) {
            that.searchForm.orderStatus = params.orderStatus.split(',').map(Number);
            return;
        }
        if (params.operType == 'apply') {
            // 处理弹框显示新增生产订单
            await that.showOrderFormClick('withoutAdd', params.param);
        }
    }
    /**
     * 排序函数
     */
    tableSort(options) {
        const that = this;
        that.searchForm.sortBy = options.prop;
        that.searchForm.sortType = options.type;
        that.searchChange();
    }
    /**
     * 打开导入对话框
     */
    openImportDialog() {
        const that = this;
        that.importDialog.visible = true;
        that.importDialog.selected = [];
        that.importDialog.searchKeyword = '';
        // 根据档案类别设置表头
        if (that.dialogOrder.formData.archiveCategory === '静配') {
            that.importDialog.headers = [
                { text: '医院名称', value: 'hospitalName', sortable: false },
                { text: '设备类型', value: 'deviceType', sortable: false },
                { text: '厂家名称', value: 'manufacturer', sortable: false },
                { text: '型号', value: 'model', sortable: false },
                { text: '外形尺寸', value: 'externalDimensions', sortable: false },
                { text: '备注', value: 'remark', sortable: false },
            ];
        }
        else if (that.dialogOrder.formData.archiveCategory === '内镜') {
            that.importDialog.headers = [
                { text: '医院名称', value: 'hospitalName', sortable: false },
                { text: '省份', value: 'province', sortable: false },
                { text: '使用科室', value: 'department', sortable: false },
                { text: '通信地址', value: 'communicationAddress', sortable: false },
                { text: '负责人', value: 'responsiblePerson', sortable: false },
                { text: '联系电话', value: 'contactPhone', sortable: false },
            ];
        }
        that.loadImportData();
    }
    /**
     * 加载导入数据
     */
    async loadImportData() {
        const that = this;
        that.importDialog.loading = true;
        try {
            let url = '';
            if (that.dialogOrder.formData.archiveCategory === '静配') {
                url = '/api/device/biosafetyCabinet/list';
            }
            else if (that.dialogOrder.formData.archiveCategory === '内镜') {
                url = '/api/device/endoscopeBrandArchive/list';
            }
            const params = {
                page: 1,
                limit: 1000,
            };
            if (that.importDialog.searchKeyword) {
                params.keyword = that.importDialog.searchKeyword;
            }
            const res = await that.axios.get(url, { params });
            that.importDialog.data = res.data.result || [];
        }
        catch (e) {
            console.error('加载导入数据失败:', e);
            that.snackbar.error('加载数据失败，请重试');
        }
        finally {
            that.importDialog.loading = false;
        }
    }
    /**
     * 搜索导入数据
     */
    searchImportData() {
        const that = this;
        clearTimeout(that.importDialog.searchTimer);
        that.importDialog.searchTimer = setTimeout(() => {
            that.loadImportData();
        }, 500);
    }
    /**
     * 导入选中数据
     */
    async importSelectedData() {
        const that = this;
        if (that.importDialog.selected.length === 0) {
            that.snackbar.warning('请选择要导入的数据');
            return;
        }
        that.importDialog.importing = true;
        try {
            const selectedItem = that.importDialog.selected[0];
            if (that.dialogOrder.formData.archiveCategory === '静配') {
                // 导入静配生物安全柜数据
                that.dialogOrder.formData.hospitalId = selectedItem.hospitalId;
                that.dialogOrder.formData.hospitalName = selectedItem.hospitalName;
                // 初始化静配相关数据结构
                if (!that.dialogOrder.formData.pivasList) {
                    that.dialogOrder.formData.pivasList = [{}];
                }
                // 设置层流台信息
                if (!that.dialogOrder.formData.pivasList[0].laminarFlowInfo) {
                    that.dialogOrder.formData.pivasList[0].laminarFlowInfo = [];
                }
                that.dialogOrder.formData.pivasList[0].laminarFlowInfo.push({
                    pyLaminarFlowModel: selectedItem.model,
                    pyLaminarFlowFactory: selectedItem.manufacturer,
                    pyLaminarFlowSize: selectedItem.externalDimensions,
                    kssSafetyCabinetModel: selectedItem.model,
                    kssSafetyCabinetFactory: selectedItem.manufacturer,
                });
            }
            else if (that.dialogOrder.formData.archiveCategory === '内镜') {
                // 导入内镜品牌档案数据
                that.dialogOrder.formData.hospitalId = selectedItem.hospitalId;
                that.dialogOrder.formData.hospitalName = selectedItem.hospitalName;
                that.dialogOrder.formData.dept = selectedItem.department;
                that.dialogOrder.formData.primaryPerson = selectedItem.responsiblePerson;
                that.dialogOrder.formData.primaryPersonContact = selectedItem.contactPhone;
                // 初始化内镜相关数据结构
                if (!that.dialogOrder.formData.endoscopeInfoList) {
                    that.dialogOrder.formData.endoscopeInfoList = [{}];
                }
                // 设置基本信息
                Object.assign(that.dialogOrder.formData.endoscopeInfoList[0], {
                    province: selectedItem.province,
                    communicationAddress: selectedItem.communicationAddress,
                    responsiblePerson: selectedItem.responsiblePerson,
                    contactPhone: selectedItem.contactPhone,
                    workStartTime: selectedItem.workStartTime,
                    workEndTime: selectedItem.workEndTime,
                    dayPatientVisits: selectedItem.dayPatientVisits,
                });
            }
            that.snackbar.success('数据导入成功');
            that.closeImportDialog();
        }
        catch (e) {
            console.error('导入数据失败:', e);
            that.snackbar.error('导入数据失败，请重试');
        }
        finally {
            that.importDialog.importing = false;
        }
    }
    /**
     * 关闭导入对话框
     */
    closeImportDialog() {
        const that = this;
        that.importDialog.visible = false;
        that.importDialog.selected = [];
        that.importDialog.data = [];
        that.importDialog.searchKeyword = '';
        clearTimeout(that.importDialog.searchTimer);
    }
    /**
     * 关闭对话框
     */
    closeDialog() {
        const that = this;
        that.dialogOrder.visible = false;
        that.dialogOrder.formData = {};
        that.dialogOrder.products = [];
    }
    /**
     * 获取档案类别样式类名
     */
    getArchiveCategoryClass(category) {
        const categoryMap = {
            静配: 'category-badge-jingpei',
            内镜: 'category-badge-neijing',
            康复: 'category-badge-kangfu'
        };
        return categoryMap[category] || 'category-badge-default';
    }
    async mounted() {
        this.skipParams();
        await this.getDataList();
        this.getHospitalList();
    }
};
__decorate([
    Getter
], CostomerManage.prototype, "userInfo", void 0);
CostomerManage = __decorate([
    Component({
        name: 'CostomerManage',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
            PreviewImg,
        },
    })
], CostomerManage);
export default CostomerManage;
